__turbopack_context__.v({
  "block": "image-module___v4zoa__block",
});
